
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useRouter } from "next/router";
import { GetServerSidePropsContext } from "next";
import { getApolloClient, addApolloState } from "@faustwp/core";
import useIsMobile from "../../../hooks/useIsMobile";
import ResultPage from "./ResultPage";
import SearchPage from "./SearchPage";
import { GetPostsInPageDocument, GetMenusDocument, } from "../../../generated/graphql";
export default function Page() {
    const isMobile = useIsMobile();
    const router = useRouter();
    const searchValue = router.query.s ? (router.query.s as string) : undefined;
    const numPostInPage = 10;
    const pageNum = Number(router.query.pageNum as string) || 1;
    const offset = (pageNum - 1) * numPostInPage - 3; // on the home there are only 7 posts
    return (<>
      {searchValue ? (<SearchPage isMobile={isMobile} searchValue={searchValue} pageNum={pageNum} offset={offset} batchSize={numPostInPage}/>) : (<ResultPage isMobile={isMobile} pageNum={pageNum} offset={offset} batchSize={numPostInPage}/>)}
    </>);
}
const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const searchValue = context.query.s ? (context.query.s as string) : undefined;
    const numPostInPage = 9;
    const pageNum = Number(context.query.pageNum as string) || 1;
    const offset = (pageNum - 1) * numPostInPage;
    const variables = {
        offset: offset,
        size: numPostInPage,
    };
    const apolloClient = getApolloClient();
    if (!searchValue) {
        const result = await Promise.all([
            apolloClient.query({
                query: GetPostsInPageDocument,
                variables,
            }),
            apolloClient.query({ query: GetMenusDocument }),
        ]);
        if (!result[0].data?.posts?.nodes ||
            result[0].data?.posts?.nodes.length === 0) {
            return {
                notFound: true,
            };
        }
    }
    return addApolloState(apolloClient, {
        props: {},
    });
};

    async function __Next_Translate__getServerSideProps__1976e6e0840__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/page/[pageNum]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1976e6e0840__ as getServerSideProps }
  